import { render, staticRenderFns } from "./LineDivider.vue?vue&type=template&id=1522e92b&scoped=true&"
import script from "./LineDivider.vue?vue&type=script&lang=js&"
export * from "./LineDivider.vue?vue&type=script&lang=js&"
import style0 from "./LineDivider.vue?vue&type=style&index=0&id=1522e92b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1522e92b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VRow})
